module.exports = __webpack_public_path__ + "static/media/il-logo-white.a67319fa.svg";